import { Icon, type IconTypes } from '@procurify/ui'

import {
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from './CatalogItemTagVariants'
import { CatalogItemTagIconStyled } from './styles/CatalogItemTagIconStyled'
import { CatalogItemTagLabelStyled } from './styles/CatalogItemTagLabelStyled'
import { CatalogItemTagLayoutStyled } from './styles/CatalogItemTagLayoutStyled'

export interface ICatalogItemTagProps {
  icon: IconTypes
  text: string
  variant?: CatalogItemTagVariant
}

export const CatalogItemTag = ({
  icon,
  text,
  variant = CatalogItemTagVariants.DEFAULT,
}: ICatalogItemTagProps) => {
  const isWarning = variant === CatalogItemTagVariants.WARNING
  const iconSize = isWarning ? 20 : 16

  return (
    <CatalogItemTagLayoutStyled $isWarning={isWarning}>
      <CatalogItemTagIconStyled $size={iconSize}>
        <Icon
          icon={icon}
          size={iconSize}
          color={isWarning ? 'yellow' : 'darkGrey'}
          aria-hidden
        />
      </CatalogItemTagIconStyled>
      <CatalogItemTagLabelStyled $isWarning={isWarning}>
        {text}
      </CatalogItemTagLabelStyled>
    </CatalogItemTagLayoutStyled>
  )
}
